import { api } from "../api";

let skip = 0;
const limit = 50;
let q = "";

export async function renderUsers(el: HTMLElement): Promise<void> {
  el.innerHTML = `<h1>Users</h1>
    <div class="toolbar">
      <input id="q" placeholder="поиск по username или tg_id" value="${q}"/>
      <button id="search">Поиск</button>
    </div>
    <div id="list">Загрузка…</div>`;

  const list = el.querySelector("#list")!;
  const search = el.querySelector<HTMLButtonElement>("#search")!;
  const qInput = el.querySelector<HTMLInputElement>("#q")!;
  search.addEventListener("click", () => { q = qInput.value.trim(); skip = 0; load(); });
  qInput.addEventListener("keypress", e => { if (e.key === "Enter") search.click(); });

  async function load(): Promise<void> {
    const { total, users } = await api.users(skip, limit, q);
    list.innerHTML = `
      <p style="color:#7b8499">${total} всего · показано ${users.length}</p>
      <div class="table-wrap"><table>
        <thead><tr>
          <th>ID</th><th>Username</th><th>Имя</th><th>Кредиты</th>
          <th>Spent $</th><th>Premium</th><th>Last seen</th><th></th>
        </tr></thead>
        <tbody>
          ${users.map(u => `
            <tr data-id="${u.id}">
              <td>${u.id}${u.is_admin ? ' <span class="tag warn">admin</span>' : ''}</td>
              <td>${u.username ? '@' + u.username : '—'}</td>
              <td>${u.first_name || ''}</td>
              <td>${u.credits}</td>
              <td>${u.total_spent_usd}</td>
              <td>${u.is_premium ? '✓' : ''}</td>
              <td>${(u.last_seen || '').slice(0, 19).replace('T', ' ')}</td>
              <td>
                <form class="row" data-grant="${u.id}">
                  <input type="number" name="delta" placeholder="+/-кр" style="width:90px"/>
                  <button>OK</button>
                </form>
              </td>
            </tr>`).join("")}
        </tbody>
      </table></div>
      <div class="toolbar" style="margin-top:16px">
        <button class="ghost" id="prev" ${skip === 0 ? "disabled" : ""}>← Назад</button>
        <button class="ghost" id="next" ${skip + limit >= total ? "disabled" : ""}>Вперёд →</button>
      </div>
    `;
    list.querySelectorAll<HTMLFormElement>("form[data-grant]").forEach(f => {
      f.addEventListener("submit", async e => {
        e.preventDefault();
        const uid = Number(f.dataset.grant);
        const delta = Number(new FormData(f).get("delta"));
        if (!delta) return;
        try {
          await api.grantCredits(uid, delta);
          load();
        } catch (err: any) {
          alert(err.message);
        }
      });
    });
    list.querySelector("#prev")!.addEventListener("click", () => { skip = Math.max(0, skip - limit); load(); });
    list.querySelector("#next")!.addEventListener("click", () => { skip += limit; load(); });
  }

  await load();
}
